import React from 'react';

export enum ScrollDirection {
    Up = "up",
    Down = "down",
    Top = "top"
}

export const useScrollDirection = ({
    initialDirection,
    thresholdPixels,
    off
}: { initialDirection?: ScrollDirection, thresholdPixels?: number, off?: boolean } = {}) => {
    const [scrollDir, setScrollDir] = React.useState(initialDirection);

    React.useEffect(() => {
        const threshold = thresholdPixels || 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;

        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                // We haven't exceeded the threshold
                ticking = false;
                return;
            }

            let dir = scrollY > lastScrollY ? ScrollDirection.Down : ScrollDirection.Up;
            if(scrollY == 0) dir = ScrollDirection.Top;

            setScrollDir(dir);
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };

        /**
         * Bind the scroll handler if `off` is set to false.
         * If `off` is set to true reset the scroll direction.
         */
        !off
            ? window.addEventListener("scroll", onScroll)
            : setScrollDir(initialDirection);

        return () => window.removeEventListener("scroll", onScroll);
    }, [initialDirection, thresholdPixels, off]);

    return scrollDir;
};